export enum ChatContextQuestionEnum {
  Default = 0,
  Goals = 1,
  Pitching = 2,
  ReleaseSchedule = 3,
  Planning = 4,
}

export const i18nEnumLabels = {
  [ChatContextQuestionEnum.Default]: "pages.Quincy.default",
  [ChatContextQuestionEnum.Goals]: "pages.Quincy.goals",
  [ChatContextQuestionEnum.Pitching]: "pages.Quincy.pitching",
  [ChatContextQuestionEnum.ReleaseSchedule]: "pages.Quincy.releaseSchedule",
  [ChatContextQuestionEnum.Planning]: "pages.Quincy.planning",
};
